import '../app-config';
import './statuspageEmbed';

document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');
